/**
 * 아이디 → 회원 번호 찾기(명세 EA-19·EA-44, 7절 C-06, 제안 03 4번·6번).
 *
 * XM-38(박탈 요청)·XM-27(등급 변경의 소속 마스터)은 회원 **번호**를 받는데, 사람은
 * 레거시처럼 **아이디**를 친다. 그래서 XM-23 포함 검색(limit 200)에서 아이디가
 * **정확히 같은 한 줄**의 번호를 쓴다.
 *
 * ⚠ **일부만 같은 것은 쓰지 않는다.** 포함 검색이라 `kim` 을 치면 `kimchi` 도 온다 —
 * 그 줄을 쓰면 엉뚱한 사람의 등급이 움직인다(시험 T-22).
 */
import { listMembers } from './admin'
import type { MemberGrade } from './types'

export async function findMemberId(loginId: string, grade?: MemberGrade): Promise<number | null> {
  const want = loginId.trim()
  if (want === '') return null
  const rows = await listMembers({ loginId: want, grade, limit: 200 })
  const hits = rows.filter((r) => r.loginId === want)
  return hits.length === 1 ? (hits[0]?.memberId ?? null) : null
}
